import waybill from '@/store/modules/logistic/waybill'
import waybillUpdate from '@/store/modules/logistic/waybillUpdate'
import fuel from '@/store/modules/logistic/fuel'
import object from '@/store/modules/logistic/object'
import objectUpdate from '@/store/modules/logistic/objectUpdate'
import transport from '@/store/modules/logistic/transport'
import transportUpdate from '@/store/modules/logistic/transportUpdate'
import driver from '@/store/modules/logistic/driver'
import driverUpdate from '@/store/modules/logistic/driverUpdate'
import reports from '@/store/modules/logistic/reports'

export default {
  namespaced: true,
  modules: {
    waybill,
    waybillUpdate,
    fuel,
    object,
    objectUpdate,
    transport,
    transportUpdate,
    driver,
    driverUpdate,
    reports
  }
}
